import { Box, Typography } from '@mui/material';
import {
  ButtonTertiary,
  GlassColors,
  GlassModal,
  GlassModalContent,
  NeumorphicButton,
} from '../../components/glassmorphism/GlassmorphismStyles';

type ConfirmModalProps = {
  open: boolean;
  title?: string;
  onClose: () => void;
  onConfirm: () => void;
  isDark?: boolean;
  confirmText?: string;
  cancelText?: string;
};

export const ConfirmModal = ({
  open,
  title = 'Are you sure?',
  onClose,
  onConfirm,
  isDark,
  confirmText = 'Yes',
  cancelText = 'No',
}: ConfirmModalProps) => {
  return (
    <GlassModal open={open} onClose={onClose} sx={{ zIndex: 999999 }}>
      <GlassModalContent sx={{ maxWidth: '400px' }}>
        <Typography
          sx={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 600,
            fontSize: '24px',
            lineHeight: '124%',
            textAlign: 'center',
            letterSpacing: '.25px',
            mb: '24px',
            color: isDark ? GlassColors.accent : GlassColors.secondary,
          }}
        >
          {title}
        </Typography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <ButtonTertiary
            sx={{
              '&&': { fontSize: '14px', height: '32px', minWidth: '66px' },
            }}
            onClick={onClose}
          >
            {cancelText}
          </ButtonTertiary>

          <NeumorphicButton
            sx={{
              '&&': { fontSize: '14px', height: '32px', minWidth: '66px' },
            }}
            onClick={onConfirm}
          >
            {confirmText}
          </NeumorphicButton>
        </Box>
      </GlassModalContent>
    </GlassModal>
  );
};
